/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/carnivalCataforyList.config.json";

export interface IGetCatagoryListMethods extends IPluginMethodMap {
  getCatagoryList(args: GetCatagoryListProps): Promise<any>;
}

export interface GetCatagoryListProps {}

export class GetCatagoryListService implements IAgentPlugin {
  readonly methods?: IGetCatagoryListMethods;

  constructor() {
    this.methods = {
      getCatagoryList: this.getCatagoryList.bind(this),
    };
  }

  async getCatagoryList(args: GetCatagoryListProps) {
    try {
        return {...config}
    } catch (err: any) {
      console.log(`error :`, err);
    }
  }
}
